import { render, staticRenderFns } from "./myCleared.vue?vue&type=template&id=88346d70&"
import script from "./myCleared.vue?vue&type=script&lang=js&"
export * from "./myCleared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports